import { useEffect, useCallback } from 'react';
import gun from '../config/gun.config';

const ANALYTICS_NODE = 'joystance_analytics';

export function useAnalytics(userId: string | null) {
  // Track page visit
  useEffect(() => {
    if (!userId) return;
    const now = Date.now();
    const today = new Date().toISOString().split('T')[0];
    const visitId = `v_${now}_${Math.random().toString(36).slice(2, 6)}`;

    gun.get(ANALYTICS_NODE).get('visits').get(visitId).put({
      userId,
      ts: now,
      date: today,
      userAgent: navigator.userAgent.slice(0, 100),
      screen: `${window.innerWidth}x${window.innerHeight}`,
    } as any);

    // Increment daily counter
    gun.get(ANALYTICS_NODE).get('daily').get(today).get('visits').once((count: any) => {
      gun.get(ANALYTICS_NODE).get('daily').get(today).get('visits').put((Number(count) || 0) + 1);
    });
  }, [userId]);

  // Track an event interaction
  const trackEvent = useCallback((action: string, data?: Record<string, any>) => {
    if (!userId) return;
    const id = `e_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`;
    gun.get(ANALYTICS_NODE).get('events').get(id).put({
      userId,
      action,
      ts: Date.now(),
      ...data,
    } as any);

    // Daily action counter
    const today = new Date().toISOString().split('T')[0];
    gun.get(ANALYTICS_NODE).get('daily').get(today).get(action).once((count: any) => {
      gun.get(ANALYTICS_NODE).get('daily').get(today).get(action).put((Number(count) || 0) + 1);
    });
  }, [userId]);

  return { trackEvent };
}
